export const iconFontAwesomeTransportationPlaneUp = (
	<i className="fa-solid fa-plane-up"></i>
);
